import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/TagGroup";

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const Create = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const GetById = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Update = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const Delete = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

/**
 * Grup içi etiket sıralarını toplu günceller.
 * @param {{ params: { tagGroupId: string }, query?: object }} options
 */
export const UpdateTagOrders = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:tagGroupId/TagOrders`, options);

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  UpdateTagOrders,
};
